import { GeConfidentialDocumentComponent } from './../modules/home/components/ge-confidential-document/ge-confidential-document.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UserRolePermissionGuard } from '../core/guards/user-router-permission.guard';
import { ApplicationCatalogComponent } from '../modules/home/components/application-catalog/application-catalog.component';
import { ApplicationTrainingDocumentComponent } from '../modules/home/components/application-training-document/application-training-document.component';
import { HomeComponent } from '../modules/home/components/home/home.component';
import { RequestGeSingleSignComponent } from '../modules/home/components/request-ge-single-sign/request-ge-single-sign.component';
import { SRM_ROUTING } from '../modules/home/components/srm/srm-routing.module';
import { CONTRACT_ROLES, DOCSTORE_ROLES, RSP_ROLES } from '../shared/enums/admin-enum';
import { DISPLAY_BREADCRUMBS, PATH_ROUTING } from '../shared/enums/routing-enums';
import { SrmComponent } from './../modules/home/components/srm/srm/srm.component';
import { ContractsComponent } from '../modules/contracts/contracts.component';
import { DocStoreComponent } from '../modules/docstore/docstore.component';
import { CanDeactivateGuard } from '../core/guards/can-deactivate.guard';
import { LandingPageHydroComponent } from '../modules/landing-page-hydro/landing-page-hydro.component';
import { EolComponent } from '../modules/eol/eol.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    data: {
      breadcrumbs: [
        { display: DISPLAY_BREADCRUMBS.HOME, url: '' },
        { display: DISPLAY_BREADCRUMBS.SUPPLIER, url: '' }
      ],
    },
  },
  {
    path:PATH_ROUTING.PATH_CONTRACT,
    component:ContractsComponent,
    loadChildren:'../modules/contracts/contracts.module#ContractsModule',
    data:{
      permissionCodes: [CONTRACT_ROLES.CONTRACT_ADMIN,CONTRACT_ROLES.CONTRACT_EDITOR,CONTRACT_ROLES.CONTRACT_VIEWER, RSP_ROLES.ADMIN]
    },
    canActivate:[UserRolePermissionGuard],
    canActivateChild:[UserRolePermissionGuard],
  },
  {
    path:PATH_ROUTING.PATH_DOCSTORE,
    component: DocStoreComponent,
    loadChildren:'../modules/docstore/docstore.module#DocStoreModule',
    data:{
      permissionCodes: [DOCSTORE_ROLES.DOCSTORE_ADMIN,DOCSTORE_ROLES.DOCSTORE_EDITOR,DOCSTORE_ROLES.DOCSTORE_VIEWER, RSP_ROLES.ADMIN]
    },
    canActivate:[UserRolePermissionGuard],
    canActivateChild:[UserRolePermissionGuard],
  },
  {
    path: PATH_ROUTING.PATH_SRM,
    component: SrmComponent,
    children: SRM_ROUTING,
  },
  {
    path: PATH_ROUTING.PATH_TRAINING_DOCUMENT,
    component: ApplicationTrainingDocumentComponent,
    data: {
      breadcrumbs: [
        { display: DISPLAY_BREADCRUMBS.HOME, url: '' },
        { display: DISPLAY_BREADCRUMBS.TRAINING_DOCUMENT, url: PATH_ROUTING.PATH_TRAINING_DOCUMENT }
      ],
      permissionCodes: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER, RSP_ROLES.OPERATOR_ACCESS, RSP_ROLES.OPERATOR_INFO,
        RSP_ROLES.SUPPLIER, RSP_ROLES.INTERNAL_USER]
    },
    canActivate: [UserRolePermissionGuard]
  },
  {
    path: PATH_ROUTING.PATH_GE_CONFIDENTIAL_DOCUMENTS,
    component: GeConfidentialDocumentComponent,
    data: {
      breadcrumbs: [
        { display: DISPLAY_BREADCRUMBS.HOME, url: '' },
        { display: DISPLAY_BREADCRUMBS.GE_CONFIDENTIAL_DOCUMENTS, url: PATH_ROUTING.PATH_GE_CONFIDENTIAL_DOCUMENTS }
      ],
      permissionCodes: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER, RSP_ROLES.OPERATOR_ACCESS, RSP_ROLES.OPERATOR_INFO,
        RSP_ROLES.SUPPLIER, RSP_ROLES.INTERNAL_USER]
    },
    canActivate: [UserRolePermissionGuard]
  },
  {
    path: PATH_ROUTING.PATH_APPLICATION_CATALOG,
    component: ApplicationCatalogComponent,
    data: {
      breadcrumbs: [
        { display: DISPLAY_BREADCRUMBS.HOME, url: '' },
        { display: DISPLAY_BREADCRUMBS.SUPPLIER, url: '' },
        { display: DISPLAY_BREADCRUMBS.APPLICATION_CATALOG, url: PATH_ROUTING.PATH_APPLICATION_CATALOG }
      ],
      permissionCodes: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER, RSP_ROLES.OPERATOR_ACCESS, RSP_ROLES.OPERATOR_INFO,
        RSP_ROLES.SUPPLIER, RSP_ROLES.INTERNAL_USER, RSP_ROLES.GE_TAG_ID_ADMIN]
    },
    canActivate: [UserRolePermissionGuard]
  },
  {
    path: PATH_ROUTING.PATH_REGISTER,
    component: RequestGeSingleSignComponent,
    data: {
      breadcrumbs: [
        { display: DISPLAY_BREADCRUMBS.HOME, url: '' },
        { display: DISPLAY_BREADCRUMBS.SUPPLIER, url: '' },
        { display: DISPLAY_BREADCRUMBS.REGISTER, url: PATH_ROUTING.PATH_REGISTER }
      ],
    },
  },
  {
    path: PATH_ROUTING.PATH_LANDING_PAGE_HYDRO,
    component: LandingPageHydroComponent,
  },
  {
    path: PATH_ROUTING.PATH_EOL,
    component: EolComponent,
    loadChildren: '../modules/eol/eol.module#EolModule',
    data: {
      permissionCodes: [RSP_ROLES.SUPER_USER, RSP_ROLES.EOL_ADMIN, RSP_ROLES.SUPPLIER]
    },
    canActivate: [UserRolePermissionGuard],
    canActivateChild: [UserRolePermissionGuard],
  },
];

@NgModule({ 
  imports: [  
    RouterModule.forRoot(routes)
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
